import _isNil from 'lodash/isNil';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import EntityDrawer from '@Components/InspectEntityComponents/EntityDrawer';
import Page from '@Components/Page/Page';
import EntitiesApi from '@Data/entities/Api';
import { selectedEntityState } from '@Data/entities/Reducer';
import FoldersApi from '@Data/folders/Api';
import { foldersState, visibleFoldersState } from '@Data/folders/Reducer';
import { IProject } from '@Data/projects/Interfaces';
import { ProjectActionType } from '@Data/projects/ProjectActionTypes';
import { selectedProjectState } from '@Data/projects/Reducer';
import { ITeam } from '@Data/teams/Interfaces';
import { selectedTeamState } from '@Data/teams/Reducer';
import ContentsDrawer from './components/Drawers/ContentsDrawer/ContentsDrawer';
import ProjectMap from './components/Map/ProjectMap';
import MapModalDialogue from './components/ProjectModalDialogue/ProjectModalDialogue';

const ProjectView = () => {
    const params = useParams();
    const visibleFolderIds = params.folderIds;
    const selectedPoleId = params.poleId;
    const selectedProject: IProject = useSelector(selectedProjectState);
    const selectedTeam: ITeam = useSelector(selectedTeamState);
    const [openDialogueType, setOpenDialogueType] =
        useState<ProjectActionType | null>(null);
    const [isLoadingFolders, setIsLoadingFolders] = useState<boolean>(true);
    const selectedPole = useSelector(selectedEntityState);
    const visibleFolders = useSelector(visibleFoldersState);
    const folders = useSelector(foldersState);

    useEffect(() => {
        // folder loading logic is in @Views/BaseViews/Workbench
        if (_isNil(folders)) {
            setIsLoadingFolders(true);
        } else if (_isNil(visibleFolderIds)) {
            setIsLoadingFolders(false);
        } else if (visibleFolders.length > 0) {
            setIsLoadingFolders(false);
        }
    }, [folders, visibleFolderIds, visibleFolders]);

    useEffect(() => {
        const getSelectedPole = async () => {
            const entityVersion = await EntitiesApi.getEntityVersionDetails(
                selectedPoleId
            );
            EntitiesApi.setSelectedEntityVersion(entityVersion);
            FoldersApi.setSelectedFolder(entityVersion.folder[0]);
        };

        if (
            visibleFolders.length > 0 &&
            !_isNil(selectedPoleId) &&
            _isNil(selectedPole)
        ) {
            getSelectedPole();
        }
    }, [visibleFolders, selectedPoleId, selectedPole]);

    const handleDialogueClose = () => {
        setOpenDialogueType(null);
    };

    const handleCompleteProcessEvent = () => {
        handleDialogueClose();
    };

    const getFolders = async () => {
        setIsLoadingFolders(true);
        await FoldersApi.getFolders(selectedProject.project_id);
        setIsLoadingFolders(false);
    };

    return (
        <React.Fragment>
            <Page>
                <ContentsDrawer
                    isLoading={isLoadingFolders}
                    selectedProject={selectedProject}
                    selectedTeam={selectedTeam}
                    onManageProject={getFolders}
                />

                <ProjectMap />

                {!_isNil(selectedPole) && (
                    <EntityDrawer selectedEntity={selectedPole} />
                )}
            </Page>
            {selectedProject && (
                <MapModalDialogue
                    type={openDialogueType}
                    isOpen={!_isNil(openDialogueType)}
                    onCancel={handleDialogueClose}
                    projectId={selectedProject.project_id}
                    onComplete={handleCompleteProcessEvent}
                />
            )}
        </React.Fragment>
    );
};

export default ProjectView;
